export const TIMELINE_DATASET_IDS = {
  TOOLBAR: 'timeline-toolbar',
  HEADER: 'timeline-header',
  SCROLL_CONTAINER: 'scroll-container__content',
}
